import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import databaseService from '../services/databaseService';
import RichTextEditor from './RichTextEditor';
import { isAuthenticated } from '../services/authService';

const EditJournal = () => {
  const { journalId } = useParams();
  const navigate = useNavigate();
  const [journalEntry, setJournalEntry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/auth/login');
      return;
    }

    loadJournalEntry();
  }, [journalId, navigate]);

  const loadJournalEntry = async () => {
    try {
      await databaseService.init();
      const entryData = await databaseService.getJournalEntry(parseInt(journalId));
      
      if (entryData) {
        setJournalEntry({
          ...entryData,
          content: entryData.content || '',
          title: entryData.title || ''
        });
      } else {
        setError('Journal entry not found');
      }
    } catch (error) {
      console.error('Failed to load journal entry:', error);
      setError('Failed to load journal entry');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (entryData) => {
    try {
      await databaseService.updateJournalEntry(journalEntry.id, {
        ...journalEntry,
        ...entryData,
        updated_at: new Date().toISOString()
      });
      
      navigate('/admin');
    } catch (error) {
      console.error('Failed to save journal entry:', error);
      alert('Failed to save journal entry. Please try again.');
    }
  };

  const handleCancel = () => {
    navigate('/admin');
  };

  if (loading) {
    return <div className="admin-container">Loading journal entry...</div>;
  }

  if (error) {
    return (
      <div className="admin-container">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <h2>Error</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/admin')} className="btn btn-primary">
            Back to Admin
          </button>
        </div>
      </div>
    );
  }

  if (!journalEntry) {
    return (
      <div className="admin-container">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <h2>Journal Entry Not Found</h2>
          <p>The journal entry you're looking for doesn't exist.</p>
          <button onClick={() => navigate('/admin')} className="btn btn-primary">
            Back to Admin
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <RichTextEditor
        initialContent={journalEntry.content}
        title={journalEntry.title}
        onSave={handleSave}
        onCancel={handleCancel}
        isEditing={true}
      />
    </div>
  );
};

export default EditJournal;
